var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Icon } from "../Icon";
var SportsCarouselItem = /** @class */ (function (_super) {
    __extends(SportsCarouselItem, _super);
    function SportsCarouselItem(props) {
        var _this = _super.call(this, props) || this;
        _this.sportId = !_this.props.sportId ? "general" : _this.props.sportId;
        _this.iconClass = _this.props.alternative ? "i-o-sport-alt-" : (_this.props.colorful ? "i-c-sport-" : "i-o-sport-");
        _this.iconClass += _this.props.sportId;
        _this.iconClass += " i-" + (_this.props.iconSize ? _this.props.iconSize : "32");
        _this.itemUat = _this.props.dataUats ? _this.props.dataUats.item : "scarousel-item";
        _this.sportNameUat = _this.props.dataUats ? _this.props.dataUats.sportName : "scarousel-item-title";
        return _this;
    }
    SportsCarouselItem.prototype.noop = function () { return false; };
    SportsCarouselItem.prototype.fnRouter = function (handler) {
        return (typeof handler !== "function" ? this.noop : handler)();
    };
    SportsCarouselItem.prototype.render = function () {
        var itemClass = "rj-sports-carousel-item" + (this.props.isSelected ? " rj-sports-carousel-item--active" : "");
        return (React.createElement("div", { className: itemClass, "data-uat": this.itemUat, onClick: this.fnRouter.bind(this, this.props.handler) },
            React.createElement(Icon, { i: this.iconClass }),
            React.createElement("div", { className: "rj-sports-carousel-item--details" },
                React.createElement("div", { className: "rj-sports-carousel-item--sportName", "data-uat": this.sportNameUat }, this.props.sportName),
                React.createElement("div", { className: "rj-sports-carousel-item--eventsCount" }, this.props.numberOfEvents))));
    };
    return SportsCarouselItem;
}(React.Component));
export { SportsCarouselItem };
//# sourceMappingURL=SportsCarouselItem.js.map